(function($){
    var $fn = $(".comp_visual");

    if($fn.length) {
        var $slider = $fn.find("[data-slider]"),
            $autoplay = !!($slider.attr("data-autoplay")),
            $autoplay_speed = ($autoplay)?$slider.data("autoplay"):0;

        if ($slider.children().length > 1) {
            $slider.slick({
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                autoplay: $autoplay,
                autoplaySpeed: $autoplay_speed,
                arrows: false,
                pauseOnHover: false,
                dots: true
            });
        }
    }
})(jQuery);